import { j as s, c as a } from "./utils-BdNIfrGQ.js";
import f from "react";
import { i as x } from "./BaseInput.styles-Bn99zfPn.js";
import { a as i } from "./Button-CzIiGCVn.js";
import "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import { F as b } from "./Flex-BA9xHq_p.js";
import { n as j } from "./normalize-spacing-DY0KSpr_.js";
import "./Grid-DJGISvmf.js";
const C = ({ append: r, prepend: n }) => r && n ? "border-r-0 border-l-0" : r ? "border-r-0 rounded-r-none rounded-l-md" : n ? "border-l-0 rounded-l-none rounded-r-md" : "rounded-md", h = f.forwardRef(
  ({ variant: r, type: n = "text", actions: t = {}, spacing: l, className: p, ...m }, d) => {
    const { append: o, prepend: e } = t, u = `${C(t)} ${p || ""}`, c = r === "search" ? "sm:w-full" : "";
    return /* @__PURE__ */ s.jsxs(b, { className: a(j(l), "flex-nowrap w-full", c), children: [
      e && /* @__PURE__ */ s.jsx(
        i,
        {
          size: "sm",
          variant: "outline",
          "aria-label": e.arialabel,
          ...e.props,
          onClick: e.props?.onClick,
          children: e.icon
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          type: n,
          className: a(x({ variant: r }), u),
          ...m,
          ref: d
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        i,
        {
          size: "sm",
          variant: "outline",
          "aria-label": o.arialabel,
          ...o.props,
          onClick: o.props?.onClick,
          children: o.icon
        }
      )
    ] });
  }
);
h.displayName = "BaseInput";
export {
  h as B
};
